import * as React from 'react';

import { times } from 'lodash';

import { ProductCardPlaceholder } from '@coursera/coursera-ui/lib/components/coursera/ProductCard';

const SearchCardsPlaceHolder = ({ count }: { count: number }) => {
  return (
    <div>
      {times(count, (i) => (
        <div key={`Placeholder-${i}`} style={{ marginBottom: 30, marginTop: 30 }}>
          <ProductCardPlaceholder size="xs" />
        </div>
      ))}
    </div>
  );
};

export default SearchCardsPlaceHolder;
